
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/mobile/avatar-tag.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-mobile-avatar-tag-demo-avatar-tag"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/mobile/avatar-tag.md?type=demo')
};